module.exports = __webpack_public_path__ + "static/media/button-edit-upload.d3345ed5.svg";